module.exports = __webpack_public_path__ + "static/media/man_typing_on_laptop.438b2240.png";